<template>
    <div>
        <b-form-group v-if="showOriginal" :label="elementLabel" :description="elementHelp">
            <b-form-input :required="required" v-model="elementValue"></b-form-input>
        </b-form-group>

        <b-form-group v-if="showTranslation" :label="elementLabel" :description="elementHelp">
            <b-input-group>
                <b-form-input :required="required" v-model="elementValue"></b-form-input>
                <template #append>
                    <country-flag :country="langcode" size="normal" class="ml-n5" />
                </template>
            </b-input-group>
        </b-form-group>
    </div>
</template>

<script>
import AdminAccessMixin from '@/mixins/AdminAccessMixin';
export default {
    name: 'FormElementInput',
    mixins: [AdminAccessMixin],
    props: {
        name: String,
        value: String,
        langcode: String,
        required: Boolean,
        notitle: Boolean,
        nohelp: Boolean
    },
    computed: {
        elementName() {
            return this.$t(`form.${this.name}`)
        },
        elementLabel() {
            return !this.notitle ? this.$t(`form.${this.name}`) : ''
        },
        elementHelp() {
            const helpTxt = this.$t(`form.${this.name}-help`)
            if (helpTxt === `form.${this.name}-help` || this.nohelp) {
                return ''
            }
            return this.$t(`form.${this.name}-help`)
        },
        elementValue: {
            get: function () {
                return this.value
            },
            set: function (value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>